function setaCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getaCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
function eraseaCookie(name) {
    document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

function seeaCookie(name) {
    console.log("cookie is " + getaCookie("utm_skiplus"));
}

function showSkiIcon(newHtml) {
    //swap ski icon in place of existing html 
    var utilNavItem = document.querySelector(".header__util-nav-list-item:first-child");
    if (utilNavItem) {
        utilNavItem.innerHTML = newHtml;
    }
}

function checkForSkiCampaign() {
    //grab URL Params
    const urlParams = new URLSearchParams(window.location.search);
    const cookieName = "utm_skiplus";
    const utmName = "utm_campaign";
    const utmSearchValue = "ski";
    const paramResult = urlParams.get(utmName);
    const cookieDurationDays = 14;
    const skiHtml = `<a class="header__util-nav-link" href="/welcome-to-winter">
  <span class="header__util-nav-icon">
    <svg width="23" height="26" viewBox="0 0 23 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0980342 19.4998C0.23403 19.7311 0.479743 19.8609 0.732313 19.8609C0.856881 19.8609 0.982593 19.8293 1.09688 19.7639L3.58938 18.3431V21.1846C3.58938 21.5841 3.91623 21.9068 4.32079 21.9068C4.72534 21.9068 5.0522 21.5841 5.0522 21.1846L5.05334 17.509L10.7686 14.25V20.7672L7.54452 22.6043C7.19482 22.8041 7.07481 23.2453 7.2771 23.5907C7.4131 23.822 7.65881 23.9518 7.91138 23.9518C8.03595 23.9518 8.16166 23.9202 8.27595 23.8547L10.7684 22.4339V25.2778C10.7684 25.6772 11.0953 26 11.4999 26C11.9044 26 12.2313 25.6772 12.2313 25.2778V22.4362L14.7238 23.857C14.8392 23.9225 14.9649 23.9541 15.0883 23.9541C15.3409 23.9541 15.5866 23.8243 15.7226 23.5929C15.9249 23.2476 15.8049 22.8052 15.4552 22.6066L12.2311 20.7683V14.2503L17.9475 17.5093V21.1849C17.9475 21.5844 18.2744 21.9071 18.6789 21.9071C19.0835 21.9071 19.4104 21.5844 19.4104 21.1849V18.3434L21.9029 19.7641C22.0183 19.8296 22.144 19.8612 22.2674 19.8612C22.52 19.8612 22.7657 19.7314 22.9017 19.5001C23.104 19.1548 22.984 18.7124 22.6343 18.5138L20.1418 17.093L22.6343 15.6722C22.984 15.4725 23.104 15.0312 22.9017 14.6859C22.6994 14.3406 22.2526 14.2221 21.9029 14.4218L18.6779 16.259L12.9627 13L18.6779 9.74098L21.902 11.5782C22.0174 11.6436 22.1431 11.6752 22.2665 11.6752C22.5191 11.6752 22.7648 11.5455 22.9008 11.3141C23.1031 10.9688 22.9831 10.5264 22.6334 10.3278L20.1409 8.90702L22.6334 7.48624C22.9831 7.28649 23.1031 6.84524 22.9008 6.49992C22.6985 6.15461 22.2517 6.0361 21.902 6.23586L19.4095 7.65664V4.8151C19.4095 4.41562 19.0826 4.09287 18.6781 4.09287C18.2735 4.09287 17.9467 4.41562 17.9467 4.8151V8.4907L12.2314 11.7497V5.23169L15.4555 3.39449C15.8052 3.19475 15.9252 2.7535 15.7229 2.40818C15.5206 2.06287 15.0738 1.94324 14.7241 2.14411L12.2316 3.56377V0.722235C12.2316 0.322753 11.9047 0 11.5001 0C11.0956 0 10.7687 0.322753 10.7687 0.722235V3.56377L8.27624 2.14299C7.92654 1.94324 7.47853 2.06174 7.2774 2.40705C7.07511 2.75237 7.19511 3.19475 7.54482 3.39337L10.7689 5.23169V11.7489L5.05246 8.49099V4.81539C5.05246 4.41591 4.72561 4.09316 4.32105 4.09316C3.9165 4.09316 3.58964 4.41591 3.58964 4.81539V7.65693L1.09714 6.23614C0.747442 6.0364 0.299438 6.15489 0.0983004 6.50021C-0.103981 6.84553 0.0160168 7.28791 0.365722 7.48652L2.85822 8.90731L0.365722 10.3281C0.0160197 10.5278 -0.10399 10.9691 0.0983004 11.3144C0.234296 11.5457 0.480009 11.6755 0.732579 11.6755C0.857147 11.6755 0.982859 11.6439 1.09714 11.5785L4.3212 9.74127L10.0376 13.0003L4.32237 16.2593L1.09831 14.4221C0.748612 14.2224 0.300608 14.3409 0.0994707 14.6862C-0.102811 15.0315 0.0171871 15.4739 0.366892 15.6725L2.85939 17.0933L0.366892 18.5141C0.016049 18.7127 -0.10282 19.1551 0.0983268 19.5004L0.0980342 19.4998Z"
        fill="black" />
    </svg>
  </span>
  <span class="header__util-nav-text">Plan Your Ski Trip</span>
  </a>`;

    if (paramResult != null) {
        if (paramResult === "" || !paramResult.includes(utmSearchValue)) {
            //param not null, but set to something else
            //clear cookie and display regular content
            eraseaCookie(cookieName);
        }
        else if (paramResult.includes(utmSearchValue)) {
            //found a matching UTM. swap HTML and set cookie
            showSkiIcon(skiHtml);
            setaCookie(cookieName, true, cookieDurationDays);
        }
    } else {
        //no match for utm, look for cookie
        if (getaCookie(cookieName)) {
            showSkiIcon(skiHtml);
        }
    }
}

checkForSkiCampaign();